/** Digital wallet types */
export var DigitalWalletType;
(function (DigitalWalletType) {
    DigitalWalletType["applePay"] = "applePay";
    DigitalWalletType["googlePay"] = "googlePay";
})(DigitalWalletType || (DigitalWalletType = {}));
;
/** Specific kinds of Google Pay Errors */
export var GooglePayErrorType;
(function (GooglePayErrorType) {
    /** Google Pay didn't succeed due to a network error */
    GooglePayErrorType["networkError"] = "NetworkError";
    /** Google Pay didn't succeed due to developer error */
    GooglePayErrorType["developerError"] = "DeveloperError";
    /** Google Pay didn't succeed due to an internal error */
    GooglePayErrorType["internalError"] = "InternalError";
})(GooglePayErrorType || (GooglePayErrorType = {}));
;
//SEE DOCUMENTATION IN README.MD
export var PromiseRejectionCode;
(function (PromiseRejectionCode) {
    PromiseRejectionCode["invalidParameter"] = "InvalidParameter";
    PromiseRejectionCode["missingParameter"] = "MissingParameter";
    PromiseRejectionCode["applePayUnsupported"] = "ApplePayUnsupported";
    PromiseRejectionCode["sdkUninitialized"] = "SdkUninitialized";
    PromiseRejectionCode["googlePayUninitialized"] = "GooglePayUninitialized";
    PromiseRejectionCode["googlePayNotReady"] = "GooglePayNotReady";
    PromiseRejectionCode["uninmplemented"] = "UNIMPLEMENTED";
    PromiseRejectionCode["generalError"] = "generalError";
})(PromiseRejectionCode || (PromiseRejectionCode = {}));
;
//SEE DOCUMENTATION IN README.MD
export const DigitalWalletReadyEvent = 'digitalWalletReadyEvent';
